<script>
import ListAction from './ListAction.vue';

/**
 * The RecusalRemover component.
 */
export default {
  extends: ListAction
};
</script>
